var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "none" } },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: { model: _vm.loginForm, "auto-complete": "on" }
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                ref: "username",
                attrs: { name: "username", type: "text" },
                model: {
                  value: _vm.loginForm.username,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "username", $$v)
                  },
                  expression: "loginForm.username"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                ref: "password",
                attrs: { type: "password", name: "password" },
                model: {
                  value: _vm.loginForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v)
                  },
                  expression: "loginForm.password"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                ref: "timestamp",
                model: {
                  value: _vm.loginForm.timestamp,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "timestamp", $$v)
                  },
                  expression: "loginForm.timestamp"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                ref: "sign",
                model: {
                  value: _vm.loginForm.sign,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "sign", $$v)
                  },
                  expression: "loginForm.sign"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }